var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sw-grid-flex sw-grid-flex--dir-column" }, [
    _c(
      "div",
      {
        staticClass:
          "sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center"
      },
      [
        _vm._l(_vm.inputFields, function(input) {
          return _c(
            "div",
            {
              key: "input-" + input.name,
              staticClass:
                "sw-grid-flex sw-grid-flex--wrap sw-grid-flex__cell-1-1 sw--padding-vert-2 sw-grid-flex--align-center"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sw-grid-flex__cell-1-6 sw-grid-flex--align-center"
                },
                [_c("h6", [_vm._v(_vm._s(input.text))])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sw-grid-flex__cell-5-6" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: input.value,
                      expression: "input.value"
                    }
                  ],
                  staticClass:
                    "sw--input-height__medium sw--font-size-14 sw--width-full",
                  attrs: { type: "text", required: "" },
                  domProps: { value: input.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(input, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          )
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.autoExplode,
                    expression: "autoExplode"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.autoExplode = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" }),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.generateParts,
                    expression: "generateParts"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.generateParts = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" }),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.hasColor,
                    expression: "hasColor"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.hasColor = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" }),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isPita,
                    expression: "isPita"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.isPita = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" }),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-1-3 sw--padding-vert-2" },
          [
            _vm.showAddNewGroup
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newGroup.name,
                      expression: "newGroup.name"
                    }
                  ],
                  staticClass:
                    "sw--input-height__medium sw--font-size-14 sw--width-half left sw--padding-right-2",
                  attrs: {
                    type: "text",
                    placeholder: "Your new group name..."
                  },
                  domProps: { value: _vm.newGroup.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.newGroup, "name", $event.target.value)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddNewGroup
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newGroup.parentId,
                        expression: "newGroup.parentId"
                      }
                    ],
                    staticClass: "sw-select--not-round sw--width-half",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.newGroup,
                          "parentId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "option",
                      {
                        domProps: {
                          value: 0,
                          selected: _vm.newGroup.parentId === 0
                        }
                      },
                      [_vm._v("-- select a parent --")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.materialGroups, function(group) {
                      return _c(
                        "option",
                        {
                          key: group.id,
                          domProps: {
                            selected: _vm.newGroup.parentId === group.id,
                            value: group.id
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(group.name) + "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              : _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.materialGroup,
                        expression: "materialGroup"
                      }
                    ],
                    staticClass: "sw-select--not-round sw--width-full",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.materialGroup = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("-- select one --")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.materialGroups, function(group) {
                      return _c(
                        "option",
                        { key: group.id, domProps: { value: group.id } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(group.name) + "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2"
          },
          [
            !_vm.materialGroup & !_vm.showAddNewGroup
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddNewGroup = true
                      }
                    }
                  },
                  [_vm._v("\n        New\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddNewGroup
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddNewGroup = false
                      }
                    }
                  },
                  [_vm._v("\n        Cancel\n      ")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-1-3 sw--padding-vert-2" },
          [
            _vm.showAddFamily
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newFamilyName,
                      expression: "newFamilyName"
                    }
                  ],
                  staticClass:
                    "sw--input-height__medium sw--font-size-14 sw--width-full",
                  attrs: {
                    type: "text",
                    placeholder: "Your new material family name..."
                  },
                  domProps: { value: _vm.newFamilyName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newFamilyName = $event.target.value
                    }
                  }
                })
              : _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.materialFamily,
                        expression: "materialFamily"
                      }
                    ],
                    staticClass: "sw-select--not-round sw--width-full",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.materialFamily = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("-- select one --")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.materialFamilies, function(family) {
                      return _c(
                        "option",
                        { key: family.id, domProps: { value: family.id } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(family.name) + "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2"
          },
          [
            !_vm.materialFamily & !_vm.showAddFamily
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddFamily = true
                      }
                    }
                  },
                  [_vm._v("\n        New\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddFamily
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddFamily = false
                      }
                    }
                  },
                  [_vm._v("\n        Cancel\n      ")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-1-3 sw--padding-vert-2" },
          [
            _vm.showAddShopperFamily
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newShopperFamilyName,
                      expression: "newShopperFamilyName"
                    }
                  ],
                  staticClass:
                    "sw--input-height__medium sw--font-size-14 sw--width-full",
                  attrs: {
                    type: "text",
                    placeholder: "Your new material shopper family name..."
                  },
                  domProps: { value: _vm.newShopperFamilyName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newShopperFamilyName = $event.target.value
                    }
                  }
                })
              : _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.materialShopperFamily,
                        expression: "materialShopperFamily"
                      }
                    ],
                    staticClass: "sw-select--not-round sw--width-full",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.materialShopperFamily = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("-- select one --")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.materialShopperFamilies, function(family) {
                      return _c(
                        "option",
                        { key: family.id, domProps: { value: family.id } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(family.name) + "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2"
          },
          [
            !_vm.materialShopperFamily & !_vm.showAddShopperFamily
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddShopperFamily = true
                      }
                    }
                  },
                  [_vm._v("\n        New\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddShopperFamily
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddShopperFamily = false
                      }
                    }
                  },
                  [_vm._v("\n        Cancel\n      ")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm._m(7),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-1-3 sw--padding-vert-2" },
          [
            _vm.showAddNewUserGroup
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newUserGroup.name,
                      expression: "newUserGroup.name"
                    }
                  ],
                  staticClass:
                    "sw--input-height__medium sw--font-size-14 sw--width-full",
                  attrs: {
                    type: "text",
                    placeholder: "Your new user group name..."
                  },
                  domProps: { value: _vm.newUserGroup.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.newUserGroup, "name", $event.target.value)
                    }
                  }
                })
              : _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userGroup,
                        expression: "userGroup"
                      }
                    ],
                    staticClass: "sw-select--not-round sw--width-full",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.userGroup = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("-- select one --")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.userGroups, function(group) {
                      return _c(
                        "option",
                        { key: group.id, domProps: { value: group.id } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(group.name) + "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell-1-2 sw--padding-vert-1 sw--padding-hor-2"
          },
          [
            !_vm.userGroup & !_vm.showAddNewUserGroup
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddNewUserGroup = true
                      }
                    }
                  },
                  [_vm._v("\n        New\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddNewUserGroup
              ? _c(
                  "button",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--big sw--cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showAddNewUserGroup = false
                      }
                    }
                  },
                  [_vm._v("\n        Cancel\n      ")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm._m(8),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ownerRestricted,
                    expression: "ownerRestricted"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.ownerRestricted = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" }),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.realMaterialRenderable,
                    expression: "realMaterialRenderable"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.realMaterialRenderable = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" }),
        _vm._v(" "),
        _vm._m(10),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sw-grid-flex__cell-2-3 sw--padding-vert-2" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isModelFixAllowed,
                    expression: "isModelFixAllowed"
                  }
                ],
                staticClass: "sw-select--not-round sw--width-half",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.isModelFixAllowed = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [_vm._v("No")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 1 } }, [_vm._v("Yes")])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sw--position-bottom\n              sw--position-left\n              sw--position-right\n              sw--position-fixed\n              sw--padding-hor-4\n              sw--padding-vert-2\n              sw-dms--bg-white\n              sw--z-index-10\n              sw-grid-flex\n              sw--border-grey-64-1\n              sw-grid-flex--align-center",
            class: _vm.materialId
              ? "sw-grid-flex--justify-flex-end"
              : "sw-grid-flex--justify-center"
          },
          [
            !_vm.materialId
              ? _c(
                  "div",
                  {
                    staticClass:
                      "sw--font-size-14 sw--margin-right-3 sw-grid-flex"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "sw--text-yellow sw--padding-right-2" },
                      [_vm._v("Warning:")]
                    ),
                    _vm._v(
                      " Saving this page will create a new inactive material in the database\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "sw-dms-button sw-dms-button--big sw-dms-button--red sw--cursor-pointer",
                on: { click: _vm.saveBasicInfo }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.materialId ? "Update" : "Save") +
                    "\n      "
                )
              ]
            )
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Auto Explode?")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Generate Parts?")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Supports Color?")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Is PITA?")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Material Group")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Material Family")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Material Shopper Family")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("User Group Restricted")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Owner Restricted?")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Real-time renderable?")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sw-grid-flex__cell-1-6 sw--padding-vert-2" },
      [_c("h6", [_vm._v("Allow Model Fixing?")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }